import './_AvailableFeedsCard.scss';
import Card from 'react-bootstrap/Card';
import Button from '../../../../ntisui/Atoms/Buttons';
import { ButtonVariant } from '../../../template/types/IHeader';
import { litrals } from '../../../../../constants/Litrals';
import { IAvaiableDataFeed } from '../types/IAvailableFeed';

const AvailableFeedsCard = (props: IAvaiableDataFeed) => {
  return (
    <Card
      className="availablefeed-card-container"
      data-testid="availavledatafeed-card"
    >
      <Card.Text className="card-text" data-testid="feed-name-text">
        {props.feedname}
        {/* <i
          data-testid="info-button"
          className="fa fa-info-circle"
          aria-hidden="true"
          onClick={() => props.onInfoIconClick()}
          tabIndex={0}
          onKeyPress={() => props.onInfoIconClick()}
        ></i> */}
      </Card.Text>
      <Button
        data-testid="card-button"
        className="card-button"
        onClick={() => props.onButtonClick()}
        variant={ButtonVariant.Primary}
        label={litrals.configureText}
      />
    </Card>
  );
};
export default AvailableFeedsCard;
